import React, {useContext} from 'react'
import Header from "../common/FeedHeader"
import './index.sass'
import {ButtonSmall} from '../common/Button'
import { useDispatch, useSelector } from 'react-redux'
import { DarkModeContext } from '../../global/Theme'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { useHistory } from 'react-router'

export default function Wallet() {
    const user = useSelector(state => state.userState)
    const { isDark } = useContext(DarkModeContext);
    const dispatch = useDispatch();
    const history = useHistory();
    
   // console.log(user);

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const gotoProfile = () => {
        history.push({
            pathname: '/profile'
        })
        dispatch({ type: 'UPDATE_NAV', payload: {
            notification: false,
            home: false,
            search: false,
            post: false,
            chat: false,
            profile: true
        } })
    }

    return (
        <div id="feedWallet">
            <Header img="profile.svg" text={user.username} handleClick={gotoProfile} />
            <div id='about-user'>
                <div id="profileInfoLeft" onClick={gotoProfile}>
                    <h1>{user.followersCount}</h1>
                    <p>Lovrs</p>
                </div>
                <div id="profileInfoDP" onClick={gotoProfile}>
                    <img src={(user.image === "") ? (user.isCreator) ? require("../../assets/icons/creator.svg") : require("../../assets/icons/viewer.svg") : user.image} />
                </div>
                <div id="profileInfoRight" onClick={gotoProfile}>
                    <h1>{user.followingCount}</h1>
                    <p>Loving</p>
                </div>
            </div>

            <div id="profileCardName">
                <p className={(isDark ? "usernamedark" : "usernamelight")} style={{marginRight: '10px'}}>{user.name}</p>
                <CopyToClipboard text={`https://lovr.online/user/${user.username}`}
                    onCopy={async () => {
                        dispatch({
                            type: 'SET_NOTIFICATION', payload: {
                                isEnabled: true,
                                text: 'Link copied to Clipboard',
                                icon: 'notifcomment.svg'
                            }
                        })
                        await sleep(3000)
                        dispatch({
                            type: 'SET_NOTIFICATION', payload: {
                                isEnabled: false,
                                text: '',
                                icon: ''
                            }
                        })
                    }}>
                <img src={require('../../assets/icons/pshare.svg')} />
                    
                </CopyToClipboard>
            </div>
            <div id="feedWalletBody">
                <p>Your available money to spend on anything that makes you happy!</p>
            </div>
            <div id="feedWalletInfo" className={(isDark) ? "feedWalletInfodark" : "feedWalletInfolight"}>
                <p>$4921</p>
                <div id="feedWalletAction">
                        <img src={require('../../assets/icons/tip_w.svg')} />
                        <p>Wallet</p>
                </div>
            </div>
        </div>
    )
}
